import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

// File uploads (photos, invoices) can take much longer than the default 15s
// axios timeout, especially on slower connections or with large files.
const FILE_UPLOAD_TIMEOUT_MS = 60_000;

class ClaimDeclarationsService {
  fetchCreationData(params) {
    return securedAxiosInstance.get("/claims_declaration/new", { params: toSnakeCase(params) });
  }

  create(params) {
    return securedAxiosInstance.post("/claims_declaration", toSnakeCase(params));
  }

  show(declarationId) {
    return securedAxiosInstance.get(`/claims_declaration/${declarationId}`);
  }

  createNewVersion(claimDeclarationId) {
    return securedAxiosInstance.post(`/claims_declaration/${claimDeclarationId}/new_version`);
  }

  update(declarationId, formData, { signal, onUploadProgress } = {}) {
    return securedAxiosInstance.put(`/claims_declaration/${declarationId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      signal,
      onUploadProgress,
      timeout: FILE_UPLOAD_TIMEOUT_MS,
    });
  }
}

export default new ClaimDeclarationsService();
